var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 157,
    viewBox: "0 0 372 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14844 225.462L129.996 133.162C182.488 95.56 250.432 92.2091 305.997 124.482L334.129 140.822C364.527 158.478 400.13 160.895 431.724 148.702M502.981 195.006L450.053 161.786C443.706 157.803 437.586 153.434 431.724 148.702M431.724 148.702C428.561 146.149 425.474 143.49 422.466 140.73L390.634 111.519C383.306 104.795 378 95.9447 375.37 86.0619C369.789 65.0871 377.013 42.641 393.529 29.6415L408.745 17.6654C419.269 9.38226 431.766 4.37368 444.832 3.20326L460.498 1.79991C476.513 0.365293 491.99 8.303 500.856 22.4985C508.235 34.3123 510.131 49.0416 506.008 62.516L500.282 81.2298C494.92 98.7541 484.465 114.036 470.411 124.891L460.975 132.18C451.86 139.22 442.004 144.734 431.724 148.702Z",
    stroke: "#2C9175",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/bottom-right.c004468db243bd77116fcfb42ece2007.svg";
export { ForwardRef as ReactComponent };